/**
 *
 *
 *
 *
 *
 */
export function assignNamespace<N, K extends keyof N>(ns: N, key: K, value: N[K]): void {
  ns[key] = Object.assign(ns[key] ?? {}, value);
}
